/* eslint-disable no-unused-expressions */
import { downloadVehicleTemplateFile as downloadVehicleTemplateFileOneMobility } from "../../../../services/api/hubcatalog/one-mobility-single-registry-service";
import { downloadVehicleTemplateFile as downloadVehicleTemplateFileSingleRegistry } from "../../../../services/api/hubcatalog/single-registry-service";

export const translations = {
  downloadedBadge: {
    id: "vehicle.single.registry.upload.templateModal.downloadedBadge",
    defaultMessage: "Download completed",
  },
  title: {
    id: "vehicle.single.registry.upload.templateModal.title",
    defaultMessage: "Download template",
  },
  subtitle: {
    id: "vehicle.single.registry.upload.templateModal.subtitle",
    defaultMessage:
      "Download an empty template to start from scratch or one filled with your current fleet registered in GoHub. Both include and update vehicles in a single submission.",
  },
  emptySheetTitle: {
    id: "vehicle.single.registry.upload.templateModal.emptySheet.title",
    defaultMessage: "Blank spreadsheet",
  },
  emptySheetDescription: {
    id: "vehicle.single.registry.upload.templateModal.emptySheet.description",
    defaultMessage:
      "Fill in new plates or enter existing ones to edit them. GoHub identifies and imports everything.",
  },
  filledSheetTitle: {
    id: "vehicle.single.registry.upload.templateModal.filledSheet.title",
    defaultMessage: "Spreadsheet with registered vehicles",
  },
  filledSheetDescription: {
    id: "vehicle.single.registry.upload.templateModal.filledSheet.description",
    defaultMessage:
      "Edit current vehicle data and add new lines. Everything will be updated at once.",
  },
  downloadAgain: {
    id: "vehicle.single.registry.upload.templateModal.downloadAgain",
    defaultMessage: "Download again",
  },
  download: { id: "download", defaultMessage: "Download" },
};

export const triggerFileDownload = (data, headers, defaultName) => {
  const contentDisposition = headers["content-disposition"];
  let fileName = defaultName;

  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(
      /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
    );
    if (fileNameMatch && fileNameMatch[1]) {
      fileName = fileNameMatch[1].replace(/['"]/g, "");
    }
  }

  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const handleDownloadTemplate = async ({
  type,
  companyId,
  integratorsSolutionsCode,
  locale,
  setIsLoading,
  onSuccess,
}) => {
  downloadVehicleTemplate(
    type,
    companyId,
    integratorsSolutionsCode,
    locale,
    setIsLoading,
    onSuccess,
    downloadVehicleTemplateFileSingleRegistry,
  );
};

export const handleDownloadTemplateOneMobility = async ({
  type,
  companyId,
  integratorsSolutionsCode,
  locale,
  setIsLoading,
  onSuccess,
}) => {
  downloadVehicleTemplate(
    type,
    companyId,
    integratorsSolutionsCode,
    locale,
    setIsLoading,
    onSuccess,
    downloadVehicleTemplateFileOneMobility,
  );
};

const downloadVehicleTemplate = async (
  type,
  companyId,
  integratorsSolutionsCode,
  locale,
  setIsLoading,
  onSuccess,
  downloadVehicleTemplateAction,
) => {
  if (!companyId) {
    console.error(
      `Company ID not provided to download the template (${type}).`,
    );
    return;
  }

  setIsLoading?.(true);

  try {
    const isFilledRequest = type === "filled";
    const emptyFileParam = !isFilledRequest;

    const response = await downloadVehicleTemplateAction(
      companyId,
      integratorsSolutionsCode || [],
      emptyFileParam,
      locale,
    );

    triggerFileDownload(
      response.data,
      response.headers,
      "template_veiculos.xlsx",
    );

    onSuccess?.(type);
  } catch (error) {
    console.error(`Error downloading the template ${type}:`, error);
  } finally {
    setIsLoading?.(false);
  }
};
